import * as React from 'react';
import {Basic} from './Basic.story';
import {Overflow} from './Overflow.story';
import {NoOverflow} from './NoOverflow.story';
import {CustomOverflow} from './CustomOverflow.story';

const basic = {
  rendered: <Basic />,
  source: `<ButtonGroup>
  <Button
    onPress={() => {
      console.log('Filter');
    }}
  >
    Filter
  </Button>
  <Button
    onPress={() => {
      console.log('Export');
    }}
  >
    Export
  </Button>
  <Button type="primary"
    onPress={() => {
      console.log('Save');
    }}
  >
    Save
  </Button>
</ButtonGroup>`,
};

const overflow = {
  rendered: <Overflow />,
  source: `<ButtonGroup>
  <Button
    onPress={() => {
      console.log('Filter');
    }}
  >
    Filter
  </Button>
  <Button
    onPress={() => {
      console.log('Export');
    }}
  >
    Export
  </Button>
  <Button type="primary"
    onPress={() => {
      console.log('Save');
    }}
  >
    Save
  </Button>
</ButtonGroup>`,
};

const noOverflow = {
  rendered: <NoOverflow />,
  source: `<ButtonGroup collapse="none">
  <Button
    onPress={() => {
      console.log('Filter');
    }}
  >
    Filter
  </Button>
  <Button
    onPress={() => {
      console.log('Export');
    }}
  >
    Export
  </Button>
  <Button type="primary"
    onPress={() => {
      console.log('Save');
    }}
  >
    Save
  </Button>
</ButtonGroup>`,
};

const customOverflow = {
  rendered: <CustomOverflow />,
  source: `<ButtonGroup
  menuTrigger={
    <Button>More actions</Button>
  }
>
  <Button
    onPress={() => {
      console.log('Filter');
    }}
  >
    Filter
  </Button>
  <Button
    onPress={() => {
      console.log('Export');
    }}
  >
    Export
  </Button>
  <Button
    type="primary"
    onPress={() => {
      console.log('Save');
    }}
  >
    Save
  </Button>
</ButtonGroup>`,
};

export const ButtonGroupExamples = {
  basic,
  overflow,
  noOverflow,
  customOverflow,
};
